import { asArray, firstRecord, unwrapData } from "../../lib/catalog";

export function normalizeTariffs(payload) {
  return asArray(unwrapData(payload)).map((item) => {
    const tariff = item.tariff || item;
    const vehicle = firstRecord(item.vehicle) || {};
    const city = firstRecord(item.city) || {};
    const type = firstRecord(item.type) || {};
    const pkg = firstRecord(item.package) || {};

    return {
      id: tariff.tariff_id || item.tariff_id,
      amount: tariff.tariff_amount || item.tariff_amount,
      vehicleId: vehicle.vehicle_id || tariff.tariff_vehicle,
      vehicleName: vehicle.vehicle_name || "Vehicle",
      vehiclePhoto: vehicle.vehicle_photo || "",
      passengers: vehicle.vehicle_passenger || "",
      baggage: vehicle.vehicle_baggage || "",
      fuel: vehicle.vehicle_fuel || "",
      cityName: city.city_name || city.name || "",
      typeName: type.price_tariff_plan || type.tariff_name || "",
      packageName: pkg.price_tariff_plan || pkg.tariff_name || "",
    };
  }).filter((item) => item.id);
}

export const EMPTY_TRANSPORT_FILTERS = {
  typeName: "",
  fuel: "",
  priceMin: "",
  priceMax: "",
};

export const TYPE_OPTIONS = [
  { value: "one_way", label: "One Way" },
  { value: "multiple_trip", label: "Multiple Trip" },
  { value: "round_trip", label: "Round Trip" },
];

export const FUEL_OPTIONS = [
  { value: "Petrol", label: "Petrol" },
  { value: "Diesel", label: "Diesel" },
  { value: "CNG", label: "CNG" },
];

export function emptyTransportFilters() {
  return { ...EMPTY_TRANSPORT_FILTERS };
}

export function countTransportFilters(filters = EMPTY_TRANSPORT_FILTERS) {
  let count = 0;
  if (filters.typeName) count += 1;
  if (filters.fuel) count += 1;
  if (filters.priceMin !== "" || filters.priceMax !== "") count += 1;
  return count;
}

function tripTypeKey(value) {
  const text = String(value || "")
    .toLowerCase()
    .replace(/[-_]+/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  if (!text) return "";
  if (text.includes("round")) return "round_trip";
  if (text.includes("multi")) return "multiple_trip";
  if (text.includes("one way") || text.includes("oneway")) return "one_way";
  return text;
}

function fuelKey(value) {
  const text = String(value || "").toLowerCase();
  if (text.includes("petrol") || text.includes("gasoline")) return "petrol";
  if (text.includes("diesel")) return "diesel";
  if (text.includes("cng")) return "cng";
  return text.trim();
}

export function transportMatchesFilters(item, filters = EMPTY_TRANSPORT_FILTERS, search = "") {
  const query = String(search || "").trim().toLowerCase();
  if (query) {
    const haystack = [item.vehicleName, item.cityName, item.typeName, item.packageName, item.fuel];
    const matchesSearch = haystack.some((value) => String(value || "").toLowerCase().includes(query));
    if (!matchesSearch) return false;
  }

  if (filters.typeName && tripTypeKey(item.typeName) !== tripTypeKey(filters.typeName)) {
    return false;
  }

  if (filters.fuel && fuelKey(item.fuel) !== fuelKey(filters.fuel)) {
    return false;
  }

  const price = Number(String(item.amount || 0).replace(/,/g, "")) || 0;
  if (filters.priceMin !== "" && price < Number(filters.priceMin)) return false;
  if (filters.priceMax !== "" && price > Number(filters.priceMax)) return false;

  return true;
}
